<template>
    <div :id="'_id' + message.id" class="flex group w-fit min-w-80 lg:max-w-[50%] max-w-[80%] items-center">

        <div v-if="!selfMessage">
            <img :src="conversation?.profile" v-if="conversation?.profile" alt=""
                class="w-8 h-8 rounded-full mx-1 dark:hidden" />
            <img src="@/assets/user5.svg" v-else alt="" class="w-8 h-8 rounded-full mx-1 dark:hidden" />

        </div>
        <div class="rounded-md flex-1">


            <div class="flex justify-between">
                <div class="flex items-center w-fit rounded-lg  mb-1 text-xs text-gray-500 ">
                    <i class=" fas fa-share mr-2   " v-if="message.isForwarded"></i>
                    <i v-if="message.isForwarded">Transféré</i>
                </div>
                <div class="text-end font-bold mb-1">
                    {{ message?.agent?.firstname ?? "" }}
                </div>
            </div>

            <div v-if="message.parent" @click="scrollToParentMessage"
                class=" w-full cursor-pointer hover:scale-95 bg-gray-900/20 border-l-4 border-l-gray-900/60  rounded-md  mb-2 flex ">

                <div class=" mx-2 line-clamp-3" >
                    <ReplyWidget :message="message.parent" />
                </div>

            </div>
            <div
                :class="selfMessage ? ' text-white rounded-full bg-teal-900 p-2  my-2 flex-1' : 'bg-gray-200 my-2 rounded-full p-2'">

                <div class="flex items-center min-w-full" v-if="false">
                    <i v-if="!wave.waveSuffer?.isPaused"
                        class="las la-play text-lg mr-1 bg-gray-400/50 rounded-full px-3 cursor-pointer"
                        @click="() => { this.wave.waveSuffer?.playPause(); this.audioPlayer.isPlaying = true }"></i>
                    <i v-else class="las la-pause text-lg mr-1 bg-gray-300/50 rounded-full px-3 cursor-pointer"
                        @click="() => { this.wave.waveSuffer?.playPause(); this.audioPlayer.isPlaying = false }"></i>
                    <div class="flex-1 py-[1px]">
                        <AudioLector :options="{
                            responsive: true,
                            waveColor: '#ffffff',
                            progressColor: '#14b8a6',

                            barWidth: 4,
                            height: 20,
                            barRadius: 4,
                            url: 'https://revews-bucket.s3.ap-southeast-1.amazonaws.com/a06mmMU3sgnzuUkH4OiHvyuUgCFdLSnJaDLBao7y.webm'
                        }" @waveSurfer="(ws) => { this.wave.waveSuffer = ws }"
                         @timeupdate="timeUpdateHandler"
                         @ready=" readyHandler"  />
                    </div>
                    <div class="flex text-[9px] ml-2">
                        {{ currentTime }} / {{ totalDuration }}
                    </div>

                </div>
                <audio controls :src="message?.content" v-if="true" ></audio>

            </div>
            <div class="flex mt-1 text-xs justify-end"><span>{{ hour }}</span></div>

        </div>
        <div class="px-2 py-1 hover:scale-95 group-hover:bg-gray-200  cursor-pointer ml-4 group-hover:visible invisible rounded-full"
            :class="selfMessage ? 'order-first ' : ''" @click="setParentReply">
            <i class="fas fa-reply  text-xs"></i>
        </div>

    </div>



</template>
<script>
import { mapFields } from 'vuex-map-fields';
import ReplyWidget from './ReplyWidget.vue';

export default {
    name: "PttMessage",
    components:{ReplyWidget},
    data() {
        return {
            audioPlayer: {
                isPlaying: false,

            },
            wave: {

                waveSuffer: null,
            },
            currentTime: '00:00',
            totalDuration: "00:00"
        }
    },
    props: {
        conversation: {
            type: Object,
            required: true
        },
        message: {
            type: Object,
            required: true
        },
        hour: {
            type: String,
            required: true
        },
        selfMessage: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    computed: {
        ...mapFields("messages/reply", {
            parentReply: "parentReply"
        })
    },
    methods: {
        setParentReply() {
            this.parentReply = this.message
        },

        formatTime(seconds) { return [seconds / 60, seconds % 60].map((v) => `0${Math.floor(v)}`.slice(-2)).join(':') },
        timeUpdateHandler(time) {
            this.currentTime = this.formatTime(time)
        },
         readyHandler(duration) {
            this.totalDuration = this.formatTime(duration)
        },
        scrollToParentMessage() {
            document.querySelector(`#_id${this.message?.parent_intern_id}`)?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
        }
    }
}
</script>